<template>
    <!-- SAVED CARDS -->
    <div>
      <div class="btn-back desk-c-pointer" @click="onBack"> 
        <div >&#10094;</div>
        <div v-if="step==='start'">{{ backLabel }}</div>
        <div v-else-if="step==='add-card'">Add a new card</div>
        <div v-else-if="step==='pay'">Pay with card</div>
      </div>
      <hr />

      <div v-show="step === 'start'">
        <!-- Cards available-->
        <div class="card-list-wr">
          <template v-if="cardsLoading">
            <pre-loader />
            <div class="loading-shade"></div>
          </template>
          

          <div v-if="userCardList.length">
            <div class="title">Saved Cards:</div>
            <user-cards-list show-del :list="userCardList" @card-click="onSavedCardClick" @card-delete="onCardDelete"/>
          </div>
          <!-- No cards -->
          <div v-else class="no-cards">
            <div class="title">No saved cards</div>
          </div>
        </div>

        <vue-button
          cls="main"
          class="my-4 deposit-button"
          @click="addCard"
        >Add a new card</vue-button>
        <hr />
        <vue-button
          cls="main"
          class="my-4 deposit-button"
          @click="onOneTimePayment"
        >Pay without card saving</vue-button>
      </div>

      <div v-if="step === 'pay'">
        <!-- <div class="title">Pay with card:</div> -->
        <hexopay-iframe 
          v-if="this.hexopayCheckout?.redirectUrl"
          ref="hexopayIframe"
          :amount="amount"
          :currency="currency"
          :url="this.hexopayCheckout?.redirectUrl"></hexopay-iframe>
      </div>

      <div v-if="step === 'add-card'">
        <!-- <div class="title">Add a new card:</div> -->
        <hexopay-iframe 
          v-if="this.hexopayTokenization?.redirectUrl"
          ref="hexopayTokenizationIframe"
          :amount="amount"
          :currency="currency"
          :url="this.hexopayTokenization?.redirectUrl"></hexopay-iframe>
      </div>
      
    </div>


</template>
  
<script>
  import PreLoader from "@/components/UI/PreLoader";
  import VueButton from "@/components/UI/VueButton";
  import HexopayIframe from "@/components/Payments/Hexopay/HexopayIframe";
  import UserCardsList from "@/components/Payments/Common/UserCardsList";

  export default {
    name: "HexopayCardFlow",
    components: {
      PreLoader,
      VueButton,
      HexopayIframe,
      UserCardsList
    },
    emits: [
      'cardClick',
      'goBack'
    ],
    data:()=>{
      return {
        cardsLoading: true,
        userCardList: [],
        hexopayCheckout: null,
        hexopayTokenization: null,
        step: 'start'
      }
    },
    props: {
      amount: {
        type: Number
      },
      currency: { // currencyCode
        type: String
      },
      redirectUrl: {
        type: String,
      },
      tokenizationUrl: {
        type: String,
      },
      isTest:  {
        type: Boolean
      },
      backLabel: {
        type: String,
        default: 'Deposit by Card'
      }
    },
    mounted () {
      if(this.$route.query?.action === 'card-added') {
        // finish adding card
        this.verifyCardAdding()
          .finally(() => {
            // remove adding cart query result to prevent reuse
            this.$router.replace({query: undefined}) 
            this.getUserCards()
          })
      }
      else {
        this.getUserCards()
      }
    },
    methods: {

      onBack() {
        if(this.step === 'start') {
          this.$emit('goBack')
        }
        else {
          this.step = 'start'
        }
      },

      getUserCards () {
        this.cardsLoading = true
        return this.API.getHexopayUserCards()
          .then(data => {
            console.log(data)
            this.userCardList = data?.creditCards
          })
          .catch(err => {
            console.log('getHexopayUserCards error', err)
            this.$toast.error('Something went wrong. Please try again later')
          })
          .finally(()=>{
            this.cardsLoading = false
          })
      },

      verifyCardAdding() {
        return new Promise((resolve, reject)=>{
          const paymentUid = this.$route.query.uid
          if (!paymentUid) {
            this.$toast.error('Something went wrong. Please try again later')
            resolve({})
          }
          else {
            this.API.getHexopayPaymentStatus(paymentUid)
            .then((data) => {
              if (data?.transaction?.status === "successful") {
                this.$toast.success('Card has been added.')
              }
              else {
                const msg = data?.transaction?.message || 'Something went wrong. Please try again later'
                this.$toast.error(msg)
              }
              resolve(data)
            })
            .catch((error) => {
              this.$toast.error('Something went wrong. Please try again later')
              reject(error)
            })
          }
        })
      },

      addCard() {
        const model = {
          amount: Number('1')?.toFixed(2),
          currency: this.currency,
          test: this.isTest,
          PaymentReturnUrl: this.tokenizationUrl,
        }

        this.API.hexopayCreateCheckoutTokenization(model)
          .then(data=>{
            this.hexopayTokenization = data?.checkout
            this.step = 'add-card'
            this.$nextTick(() => {
              // HEXOPAY IFRAME
              this.$refs?.hexopayTokenizationIframe.payment()
            })
          })
          .catch(err => {
            this.toast.error('Something went wrong. Please try again later')
            console.log('getHexopayCreateCheckout error', err)
            this.$toast.error('Something went wrong. Please try again later')
          })
      },

      onCardDelete(card) {
        this.API.hexopayDeleteTokenization(card.id)
          .then(data=>{
            if (data.success) {
              this.$toast.success('Card has been removed.')
              this.getUserCards()
            }
            else {
              this.$toast.error('Something went wrong. Please try again later')
            }
          })
          .catch((err) => {
            this.$toast.error('Something went wrong. Please try again later')
            console.error('hexopayDeleteTokenization err', err)
          })

      },
      onSavedCardClick(card) {
        this.$emit('cardClick', card)
        this.createCheckoutPayment(card.id)
      },

      onOneTimePayment(){
        this.createCheckoutPayment()
      },

      createCheckoutPayment(cardId) {
        const model = {
          ...(cardId ? { creditCardId: cardId } : {}),
          amount: Number(this.amount)?.toFixed(2),
          currency: this.currency,
          test: this.isTest,
          PaymentReturnUrl: this.redirectUrl,
        }

        this.API.hexopayCreateCheckoutPayment(model)
          .then(data=>{
            this.hexopayCheckout = data?.checkout
            this.step = 'pay'
            this.$nextTick(() => {
              // HEXOPAY IFRAME
              this.$refs?.hexopayIframe.payment()
            })
          })
          .catch(err => {
            console.log('getHexopayCreateCheckout error', err)
            this.$toast.error('Something went wrong. Please try again later')
          })
      }

    }
  }
</script>
  
<style scoped lang="scss">
  .btn-back {
    font-size: 1.125rem;
    font-weight: 600;
    margin: 0 1.5rem;
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: 1rem 1fr;
  }
  .title {
    font-size: 1.125rem;
    font-weight: 600;
    text-align: center;
    margin: 0.5rem 0;
  }
  .card-list-wr {
    position: relative;
    min-height: 5.6875rem;
  }
  .no-cards {
    display: flex;
    // grid-template-columns: 1rem 3.375rem 1fr;
    align-items: center;
    background-color: #2e2e2e;
    border-radius: 0.25rem;
    padding: 0.25rem 1rem;
    justify-content: center;
    height: 5.625rem;
  }

  .loading-shade {
    opacity: 1;
  }
</style>